export const geomFieldsIgnored = [
  'st_area(geom)',
  'st_length(geom)',
  'st_length(geometria)',
  'geometria',
  'st_area(shape)',
  'st_length(shape)',
  'st_perimeter(shape)',
  'shape',
];

export const systemFieldTypesIgnored: __esri.Field['type'][] = [
  'oid',
  'global-id',
  'geometry',
  'guid',
  'raster',
  'blob',
];
